module.exports = __webpack_public_path__ + "static/logo-susodigital-com-f50da0919ead081b9d63bb6dbf4db9ff.png";